//remove: [MANAGER]
//remove: [MANAGER]
//remove: [MANAGER]
//remove: [MANAGER]
//async function call_alert(str: string): Promise<void> {

"use strict"; 
import { oBase, Ilk, oBool, oColor, oCsv, oDaton, oDatim, oDouble, oFloat, oHomin, oInt16, oInt32, oInt64, oMay, oMemo, oText, oWkd } from "../util/ovars";
import { jsDebug } from "../util/classes";
import { UTL } from "../util/classes";
import { TRANS } from "../util/classes";
import { TABLE, TableObject, TBLSCROLLER, TABLE_Location } from "../util/classes";
import { Elcon } from "../util/classes";
import { DLG } from "../util/classes";
import { GSP } from "../util/classes";
import { CMP } from "../util/cmp";
import { SMART_CMP } from "../util/smart_cmp";
import { Whisper } from "../util/classes";
import { VECTOR, VECTOR_Task, VECTOR_Capsule, VECTOR_Info } from "../util/classes";
import { CdFnCntPayload } from "../util/classes";
import { COMM_LOGIC_TYPE } from "../util/classes";
import { DIALOG500 } from "../util/dialog500";
import { cmux_refresh_site, cmux_event_is_locked, cmux_change_locked_status_for_event, goto_cumx_support_page } from "../apps/cmux_general";
import { AlertPlus } from "../util/popupPlus_Alert";
import { ConfirmPlus } from "../util/popupPlus_Confirm";
import { AnnouncePlus } from "../util/popupPlus_Announce";
import { PopupPlusStyleRecord, PopupPlusAuxFunctions } from "../util/popupPlus_Aux";


declare var working_org_code: string; // cshtml המשתנה הזה מוגדר בקובץ

declare var var_disable_auto_fill_for_debug: boolean; // cshtml נמצא בתוך הקובץ
let globalVar_sum = 0;
let var_sum_of_second_option = 0;


//1
function trans_string_to_number(str: string): number {
    if (str == "") {
        return 0;
    }
    const num = parseInt(str);
    return num;
}

function trans_product_code_to_amount_number_as_number(product_code: number): number {
    const amount_element = trans_product_code_to_amount_element(product_code);
    if (amount_element == null) {
        return 0; // לא ברור לי מה צריך להחזיר כאן
    }
    const amount_as_number = trans_string_to_number(amount_element.value);
    return amount_as_number
}

function trans_product_code_to_product_name(product_code: number): string {
    const title_element =  trans_product_code_to_title_element(product_code);
    const product_name_str = title_element.textContent;
    return product_name_str;
}

function trans_amount_element_to_product_code(amount_element: HTMLInputElement): number {
    const name_str = amount_element.name;
    const product_code = extract_last_number_from_string_as_number(name_str) 
    return product_code;
}
//7
function trans_amount_element_to_value_as_number(amount_element: HTMLInputElement): number {
    const value_str: string = amount_element.value
    const value_as_number: number = trans_string_to_number(value_str);
    return value_as_number;
}
//8
function trans_amount_element_to_max_as_number(amount_element: HTMLInputElement): number {
    const max_str: string = amount_element.max;
    const value_as_number: number = trans_string_to_number(max_str);
    return value_as_number;
}

//10
function trans_product_code_to_max_allowed(product_code: number): number {
    const id_str = `id-max-units-for-product-${product_code}`;
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    if (element == null) {
        return 0; // לא ברור לי מה צריך להחזיר כאן
    }
    const num = extract_last_number_from_string_as_number(element.value);
    return num
}

function prevent_digits_and_dot(event: KeyboardEvent): boolean {
    // amount למקשי הספרות באלמנט diable המטרה כאן לבצע
    const blockedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."];
    //if (blockedKeys.includes(event.key)) {
    //    event.preventDefault();  // Block the key press (digit)
    //    return false;  // Optionally, return false to stop further action
    //}
    if (blockedKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        return false;
    }
    return true;  // Allow all other keys
}


function create_list_of_all_products_obsoelete(): void {
    let products_list = [];    
}

function fetch_zacaut_plus_factor_number_as_number(): number {
    // יש לבדוק string ובפועל החזירה number הערה מ 5.4.2026 פה !!!שינינו!!! הפונקציה אמורה היתה להחזיר
    // יש לבדוק string ובפועל החזירה number הערה מ 5.4.2026 פה !!!שינינו!!! הפונקציה אמורה היתה להחזיר
    // יש לבדוק string ובפועל החזירה number הערה מ 5.4.2026 פה !!!שינינו!!! הפונקציה אמורה היתה להחזיר
    // יש לבדוק string ובפועל החזירה number הערה מ 5.4.2026 פה !!!שינינו!!! הפונקציה אמורה היתה להחזיר 
    let element: HTMLInputElement = document.getElementById("id-zacaut-plus-factor") as HTMLInputElement;
    const num = Number(element.value);  //<<-------- כאן שינינו יש לבדוק
    return num;
}




function amount_element_exist_for_product(product_code: number): boolean {
    const amount_element = trans_product_code_to_amount_element(product_code);
    if (amount_element != null) {
        return true;
    }
    else {
        return false;
    }
}

function amount_element_is_empty_or_contain_zero(product_code: number): boolean {
    //const element = get_amount_element_given_product_code(product_code);
    const amount_element = trans_product_code_to_amount_element(product_code);
    if (amount_element == null) {
        return false; // לא ברור לי מה צריך להחזיר במקרה זה
    }
    if (amount_element.value == "") {
        return true;
    }
    const num = trans_string_to_number(amount_element.value);
    if (num == 0) {
        return true;
    }
    else {
        return false;
    }
}

function amount_element_exist_and_empty(product_code: number): boolean {
    let does_exist = amount_element_exist_for_product(product_code);
    if (does_exist == false) {
        return false;
    }
    let is_empty = amount_element_is_empty_or_contain_zero(product_code);
    if (is_empty == false) {
        return false;
    }
    //-----------------------
    return true;
}

//OOOOO
function put_string_in_remark_element_for_product(product_code: number, new_value_as_str: string): void {
    //let element = get_remark_element_given_product_code(product_code);
    const remark_element: HTMLInputElement = trans_product_code_to_remark_element(product_code) as HTMLInputElement;
    if (remark_element != null) {
        remark_element.value = new_value_as_str; 
    }
}


function put_string_in_amount_element_for_product(product_code: number, new_value_as_str: string): void {
    //let element = get_amount_element_given_product_code(product_code);
    const amount_element = trans_product_code_to_amount_element(product_code);
    if (amount_element != null) {
        amount_element.value = new_value_as_str; 
    }
}


function put_1_in_amount_element_for_product(product_code: number): void {
    //let element = get_amount_element_given_product_code(product_code);xx
    //if (element != null) {
    //    element.value = 1; 
    // }
    put_string_in_amount_element_for_product(product_code, "1")
}

function update_elements_of_sums(): void {
    const sum_as_number: number = globalVar_sum;
    const zacaut_plus_factor_as_number: number = fetch_zacaut_plus_factor_number_as_number();
    let element: HTMLInputElement = document.getElementById("id-sum-of-products") as HTMLInputElement;
    const sum_as_str: string = "&nbsp" + String(sum_as_number) + "&nbsp";
    //sum_as_str = String(sum_as_number);

    element.innerHTML = sum_as_str;
    if (sum_as_number <= zacaut_plus_factor_as_number) {
        element.style.backgroundColor = "lime" ; // lime
    }
    if (sum_as_number > zacaut_plus_factor_as_number) {
        element.style.backgroundColor = "#f5b7b1";
    }
    
}


// 1. הגדרת הממשק (Interface) לפי השדות שנוצרו בדף
interface CategoryInfo {
    //------------------------------------------------------------------------------------------
    //                                    cmux_client_cart.cshtml המידע לגבי הקטגוריות בא מהקובץ
    //Model.cashew.javascript_array_of_categories_str אנחנו מייצרים את המידע הזה באמצעות המחרוזת
    //                           בא להתאים לרשימה שנמצאת בתוך הקובץ הזה interface CategoryInfo ה
    //------------------------------------------------------------------------------------------
    //                                    cmux_client_cart.cshtml המידע לגבי הקטגוריות בא מהקובץ
    //Model.cashew.javascript_array_of_categories_str אנחנו מייצרים את המידע הזה באמצעות המחרוזת
    //                           בא להתאים לרשימה שנמצאת בתוך הקובץ הזה interface CategoryInfo ה
    //------------------------------------------------------------------------------------------
    code: number;
    name: string;
    limit: number;
}

// 2. הצהרה על המשתנה הגלובלי שהזרקת לדף
declare global {
    //------------------------------------------------------------------------------------------
    //                                    cmux_client_cart.cshtml המידע לגבי הקטגוריות בא מהקובץ
    //Model.cashew.javascript_array_of_categories_str אנחנו מייצרים את המידע הזה באמצעות המחרוזת
    //                           בא להתאים לרשימה שנמצאת בתוך הקובץ הזה interface CategoryInfo ה
    //------------------------------------------------------------------------------------------
    //                                    cmux_client_cart.cshtml המידע לגבי הקטגוריות בא מהקובץ
    //Model.cashew.javascript_array_of_categories_str אנחנו מייצרים את המידע הזה באמצעות המחרוזת
    //                           בא להתאים לרשימה שנמצאת בתוך הקובץ הזה interface CategoryInfo ה
    //------------------------------------------------------------------------------------------
    interface Window {
        list_of_categories: CategoryInfo[];
    }
}

function create_list_of_all_product_codes(): number[] {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    let result_list = [];
    const product_elements_list = document.querySelectorAll(".cl-product-container");
    for (let i = 0; i < product_elements_list.length; i++) {
        let product_element = product_elements_list[i];
        const product_code = UTL.extract_last_number_from_string_as_number(product_element.id);
        result_list.push(product_code);
    }
    return result_list;
}

function create_list_of_all_group_codes(): number[] {
    // יגאל מוסקו
    // פונקציה חדשה מתאריך 14.4.2026
    // פונקציה חדשה מתאריך 14.4.2026
    let result_list = [];
    const product_elements_list = document.querySelectorAll(".cl-group-container");
    for (let i = 0; i < product_elements_list.length; i++) {
        let product_element = product_elements_list[i];
        const product_code = UTL.extract_last_number_from_string_as_number(product_element.id);
        result_list.push(product_code);
    }
    return result_list;
}




function create_list_of_all_category_codes(): number[] {
    let result_list = [];
    const product_elements_list = document.querySelectorAll(".cl-group-container");
    for (let i = 0; i < window.list_of_categories.length; i++) {
        const rec: CategoryInfo = window.list_of_categories[i];
        const category_code = rec.code;
        result_list.push(category_code);
    }
    return result_list;
}


function trans_product_code_to_product_element_id_string(product_code: number): string {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    const id_str = `id-product-element-${product_code}`;
    return id_str;
}


function trans_product_code_to_product_element(product_code: number): HTMLInputElement {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    const id_str = trans_product_code_to_product_element_id_string(product_code);
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    if (element == null) {
        alert("trans_product_code_to_product_element(). this should not be null")
    }
    return element;
}

function trans_group_code_to_group_element_id_string(group_code: number): string {
    // פונקציה חדשה מתאריך 14.4.2026
    // פונקציה חדשה מתאריך 14.4.2026
    const id_str = `id-group-element-${group_code}`;
    return id_str;
}


function trans_group_code_to_group_element(group_code: number): HTMLInputElement {
    // פונקציה חדשה מתאריך 14.4.2026
    // פונקציה חדשה מתאריך 14.4.2026
    const id_str = trans_group_code_to_group_element_id_string(group_code);
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    if (element == null) {
        alert("trans_group_code_to_group_element(). this should not be null")
    }
    return element;
}



function trans_product_code_to_product_hr_element_id_string(product_code: number): string {
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    const id_str = `id-hr-product-${product_code}`;
    return id_str;
}

function trans_group_code_to_group_hr_element_id_string(group_code: number): string {

    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    // פונקציה חדשה מתאריך 14.4.2026
    // פונקציה חדשה מתאריך 14.4.2026

    const id_str = `id-hr-group-${group_code}`;
    return id_str;
}




function trans_product_code_to_product_hr_element(product_code: number): HTMLInputElement {
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    const id_str = trans_product_code_to_product_hr_element_id_string(product_code);
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    if (element == null) {
        alert("trans_product_code_to_product_element(). this should not be null")
    }
    return element;
}

function trans_group_code_to_group_hr_element(group_code: number): HTMLInputElement {
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    // <hr>  להזכירך מדובר פה בקו המפריד. כלומר באלמנט
    const id_str = trans_group_code_to_group_hr_element_id_string(group_code);
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    if (element == null) {
        alert("trans_group_code_to_group_element(). this should not be null")
    }
    return element;
}

function trans_product_code_to_checkbox1_id_string(product_code: number): string {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    const id_str: string = `id_checkbox1-${product_code}`;
    return id_str;
}

function trans_product_code_to_checkbox1_element(product_code: number): HTMLInputElement {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    const id_str: string = trans_product_code_to_checkbox1_id_string(product_code);
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    return element;
}

function trans_product_code_to_checkbox2_id_string(product_code: number): string {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    const id_str: string = `id_checkbox2-${product_code}`;
    return id_str;
}


function trans_product_code_to_checkbox2_element(product_code: number): HTMLInputElement {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    const id_str: string = trans_product_code_to_checkbox2_id_string(product_code);
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    return element;
}


function trans_product_code_to_amount_id_string(product_code: number) {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    const id_str: string = `id-amount-${product_code}`;
    return id_str;
}

function trans_product_code_to_amount_element(product_code: number): HTMLInputElement {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    const id_str = trans_product_code_to_amount_id_string(product_code);
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    return element;
}

function trans_product_code_to_remark_id_string(product_code: number): string {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    const id_str: string = `id-remark-${product_code}`;
    return id_str;
}

function trans_product_code_to_remark_element(product_code: number): HTMLInputElement {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    const id_str: string = trans_product_code_to_remark_id_string(product_code);
    const element: HTMLInputElement = document.getElementById(id_str) as HTMLInputElement;
    return element;
}

function trans_product_code_to_title_id_string(product_code: number): string {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    const id_str: string = `id-product-title-${product_code}`;
    return id_str;
}

function trans_product_code_to_title_element(product_code: number): HTMLElement {
    // פונקציה חדשה מתאריך 20.5.2025
    // פונקציה חדשה מתאריך 20.5.2025
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    // וזה מצב תקין. זה יכול להיות למשל כאשר המוצר אינו במלאי null שים לב שפונקציה זו עשויה להחזיר 
    const id_str: string = trans_product_code_to_title_id_string(product_code);
    const element: HTMLElement = document.getElementById(id_str) as HTMLElement;
    return element;
}



function product_has_amount_element(product_code: number): boolean {
    // למשל  amount שים לב שלא לכל מוצר יש
    // 1 יש מוצרים ללא כמות 
    // 2 יש מוצרים שהם NOT AVAILAVLE ואז אין כמות עבורים
    const amount_element: HTMLInputElement = trans_product_code_to_amount_element(product_code);
    if (amount_element != null) {
        return true;
    }
    else {
        return false;
    }
}

function product_has_remark_element(product_code: number): boolean {
    // למשל  remark שים לב שלא לכל מוצר יש
    // 1 יש מוצרים ללא כמות 
    // 2 יש מוצרים שהם NOT AVAILAVLE ואז אין כמות עבורים
    const remark_element: HTMLInputElement = trans_product_code_to_remark_element(product_code);
    if (remark_element != null) {
        return true;
    }
    else {
        return false;
    }
}

function product_has_checkbox1(product_code: number): boolean {
    // NOT AVAILAVLE למשל מוצרים שהם  checkbox1 שים לב שלא לכל מוצר יש
    // NOT AVAILAVLE למשל מוצרים שהם  checkbox1 שים לב שלא לכל מוצר יש
    // NOT AVAILAVLE למשל מוצרים שהם  checkbox1 שים לב שלא לכל מוצר יש
    const checkbox1_element: HTMLInputElement = trans_product_code_to_checkbox1_element(product_code);
    if (checkbox1_element != null) {
        return true;
    }
    else {
        return false;
    }
}

function product_has_checkbox2(product_code: number): boolean {
    // NOT AVAILAVLE למשל מוצרים שהם  checkbox2 שים לב שלא לכל מוצר יש
    // NOT AVAILAVLE למשל מוצרים שהם  checkbox2 שים לב שלא לכל מוצר יש
    // NOT AVAILAVLE למשל מוצרים שהם  checkbox2 שים לב שלא לכל מוצר יש
    const checkbox2_element: HTMLInputElement = trans_product_code_to_checkbox2_element(product_code);
    if (checkbox2_element != null) {
        return true;
    }
    else {
        return false;
    }
}

function product_has_checkboxes_and_at_least_one_is_checked(product_code: number): boolean {
    const checkbox1_element = trans_product_code_to_checkbox1_element(product_code);
    const checkbox2_element = trans_product_code_to_checkbox2_element(product_code);
    if (checkbox1_element != null && checkbox1_element.checked == true) {
        return true;
    }
    if (checkbox2_element != null && checkbox2_element.checked == true) {
        return true;
    }
    return false;
}




function scan_all(): void {
    //debugger;
    const list_of_product_codes: number[] = create_list_of_all_product_codes();
    const list_of_group_codes: number[] = create_list_of_all_group_codes();
    const list_of_category_codes: number[] = create_list_of_all_category_codes();
    //alert(list_of_group_codes);
    globalVar_sum = 0; // בינתיים משתמשים במשתנה גלובלי. נראה מה צריך לעשות בהמשך
    var_sum_of_second_option = 0;
    
    for (let i = 0; i < list_of_product_codes.length; i++) {
        const product_code: number = list_of_product_codes[i];
        const product_element: HTMLElement = trans_product_code_to_product_element(product_code);
        const checkbox1_element: HTMLInputElement = trans_product_code_to_checkbox1_element(product_code);
        const checkbox2_element: HTMLInputElement = trans_product_code_to_checkbox2_element(product_code);
        const amount_element: HTMLInputElement = trans_product_code_to_amount_element(product_code);
        const has_amount: boolean = product_has_amount_element(product_code);
        if (amount_element != null) {
            const bval = checkbox1_element.checked;
            if (bval == true) { // אנחנו סוכמים רק מה שהוזמן 
                const amount_as_number: number = trans_string_to_number(amount_element.value);
                if (amount_as_number != 0) {
                    globalVar_sum = globalVar_sum + amount_as_number;
                }
            }
        }
        if (checkbox2_element != null) {
            if (checkbox2_element.checked) {
                if (has_amount == true) {
                    var_sum_of_second_option += 1;
                }
            }
        }
    }
    update_elements_of_sums();
}


function set_amount_to_1_if_exist_and_if_empty(product_code: number): void {
    if (amount_element_exist_and_empty(product_code) == true) {
        //put_1_in_amount_element_for_product(product_code)
        put_string_in_amount_element_for_product(product_code, "1")
    }
}


function respond_checkbox1_change(product_code: number): void {
    if (var_disable_auto_fill_for_debug == true) {
        return;
    }
    const checkbox1_element: HTMLInputElement = trans_product_code_to_checkbox1_element(product_code);
    const checkbox2_element: HTMLInputElement = trans_product_code_to_checkbox2_element(product_code);
    if (checkbox1_element.checked == true) {
        checkbox2_element.checked = false;
    }
    if (checkbox1_element.checked == false)
    {
        put_string_in_amount_element_for_product(product_code, "")
        put_string_in_remark_element_for_product(product_code, "")
    }
    if (checkbox1_element.checked == true || checkbox2_element.checked == true)
    {
        set_amount_to_1_if_exist_and_if_empty(product_code);
    }
    scan_all()
}




function respond_checkbox2_change(product_code: number): boolean {
    if (var_disable_auto_fill_for_debug == true) {
        return;
    }
    const checkbox1_element: HTMLInputElement = trans_product_code_to_checkbox1_element(product_code);
    const checkbox2_element: HTMLInputElement = trans_product_code_to_checkbox2_element(product_code);
    if (checkbox2_element.checked == true) {
        checkbox1_element.checked = false;
    }
    if (checkbox2_element.checked == false)
    {
        put_string_in_amount_element_for_product(product_code, "")
        put_string_in_remark_element_for_product(product_code, "")
    }
    if (checkbox1_element.checked == true || checkbox2_element.checked == true)
    {
        set_amount_to_1_if_exist_and_if_empty(product_code);
    }
    scan_all()
}


function respond_to_input_amount_and_input_remark_change(product_code: number): void {
    //alert("respond_to_input_amount_and_input_remark_change product_code=" + product_code);
    //alert(`handleInputChange() has been called`)
    turn_on_main_checkbox_if_both_unchecked(product_code);
    scan_all();
}


function extract_last_number_from_string_as_number(str: string): number {

    //let parts = str.split("-"); // Split the string by "-"
    //let lastPart = parts[parts.length - 1]; // Get the last part
    //let number = parseInt(lastPart, 10); // Convert it to an integer
    //return number; // Return the final number
    const result_number: number = UTL.extract_last_number_from_string_as_number(str);
    return result_number;
}



function check_if_each_amounts_are_ok(): boolean {
    // TS ל JS פונקציה זו עברה שינויים משמעות בהסבה מ
    // TS ל JS פונקציה זו עברה שינויים משמעות בהסבה מ
    // TS ל JS פונקציה זו עברה שינויים משמעות בהסבה מ
    let problem_exist: boolean = false;
    const amoumnts_array: NodeListOf<HTMLInputElement> = document.querySelectorAll(".cl-amount-input");
    for (let i = 0; i < amoumnts_array.length; i++) {
        const amount_element: HTMLInputElement = amoumnts_array[i];
        const product_code: number = trans_amount_element_to_product_code(amount_element);
        const product_name: string = trans_product_code_to_product_name(product_code)
        const value_as_number: number = trans_amount_element_to_value_as_number(amount_element);
        const max_as_number: number = trans_amount_element_to_max_as_number(amount_element);
        // max_as_number בשלב זה בודקים רק אם קיים
        if (max_as_number != 0) {
            if (value_as_number > max_as_number) {
                let msg_str = "";
                msg_str += "הפריט" + " " + product_name + "הוזמן מעל הכמות המקסימלית" + "\n";
                msg_str += "הכמות המוזמנת היא" + ": " + value_as_number + "\n";
                msg_str += "הכמות המקסימלית לפריט זה היא" + ": " + max_as_number + "\n";
                msg_str += "עליך לתקן את ההזמנה לגבי פריט זה" + ": " +  "\n";
                alert(msg_str);
                problem_exist = true
            }
        }
    }
    let all_ok: boolean = !problem_exist;
    return all_ok;
}

function is_sum_of_all_amounts_is_too_small(): boolean {
    const zacaut_plus_factor = fetch_zacaut_plus_factor_number_as_number();
    if (globalVar_sum < zacaut_plus_factor) {
        return true; // i.e. ok
    }
    else {
        return false;
    }
}

function is_sum_of_all_amounts_is_too_big(): boolean {
    const zacaut_plus_factor: number = fetch_zacaut_plus_factor_number_as_number();
    if (globalVar_sum > zacaut_plus_factor) {
        return true; // i.e. ok
    }
    else {
        return false;
    }
}


function turn_on_main_checkbox_if_both_unchecked(product_code: number): void {
    //alert("turn_on_main_checkbox_if_both_unchecked product_code=" + product_code);
    //const id_of_checkbox_request_prodect_str = trans_product_code_to_id_of_checkbox_of_request_product(product_code);
    //const id_of_checkbox_is_second_option_str = trans_product_code_to_id_of_checkbox_of_is_second_option(product_code);
    //const checkbox_request_product = document.getElementById(id_of_checkbox_request_prodect_str);
    //const checkbox_is_second_option = document.getElementById(id_of_checkbox_is_second_option_str);
    const checkbox1_element: HTMLInputElement = trans_product_code_to_checkbox1_element(product_code);
    const checkbox2_element: HTMLInputElement = trans_product_code_to_checkbox2_element(product_code);
    if (checkbox1_element.checked == false && checkbox2_element.checked == false) {
        checkbox1_element.checked = true;
    }
}

function turn_off_main_checkbox_if_only_main_checkbox_checked(product_code: number): void {
    //alert("turn_on_main_checkbox_if_both_unchecked product_code=" + product_code);
    //const id_of_checkbox_request_prodect_str = trans_product_code_to_id_of_checkbox_of_request_product(product_code);
    //const id_of_checkbox_is_second_option_str = trans_product_code_to_id_of_checkbox_of_is_second_option(product_code);
    //const  checkbox_request_product = document.getElementById(id_of_checkbox_request_prodect_str);
    //const  checkbox_is_second_option = document.getElementById(id_of_checkbox_is_second_option_str);
    const checkbox1_element: HTMLInputElement = trans_product_code_to_checkbox1_element(product_code);
    const checkbox2_element: HTMLInputElement = trans_product_code_to_checkbox2_element(product_code);
    if (checkbox1_element.checked == true && checkbox2_element.checked == false) {
        checkbox1_element.checked = false;
    }
}




function respond_amount_minus_button(product_code: number): void {
    //const element = get_amount_element_given_product_code(product_code);
    const amount_element: HTMLInputElement = trans_product_code_to_amount_element(product_code);
    if (amount_element == null) {
        return;
    }
    let amount_as_number: number = trans_product_code_to_amount_number_as_number(product_code);
    if (amount_as_number == 0) {
        return;
    }
    amount_as_number = amount_as_number - 1; 
    amount_element.value = amount_as_number.toString();
    if (var_disable_auto_fill_for_debug == false) {
        if (amount_as_number == 0) {
            turn_off_main_checkbox_if_only_main_checkbox_checked(product_code);
        }
    }
    scan_all();
    update_elements_of_sums();
}


function respond_amount_plus_button(product_code: number): void {
    //alert("respond_amount_plus_button: " + product_code);
    //let element = get_amount_element_given_product_code(product_code);
    const amount_element = trans_product_code_to_amount_element(product_code);
    let max_allowed = trans_product_code_to_max_allowed(product_code);
    if (amount_element == null) {
        return
    }
    let amount_as_number = trans_product_code_to_amount_number_as_number(product_code);
    if (amount_as_number > max_allowed - 1) {
        return;
    }
    amount_as_number = amount_as_number + 1; 
    amount_element.value = amount_as_number.toString();
    if (var_disable_auto_fill_for_debug == false) {
        if (amount_as_number > 0) {
            turn_on_main_checkbox_if_both_unchecked(product_code);
        }
    }
    scan_all();
    update_elements_of_sums();
}



function respond_remark_input_changed(product_code: number): void {
    if (var_disable_auto_fill_for_debug == true) {
        return;
    }
    //let element = get_remark_element_given_product_code(product_code);
    const remark_element = trans_product_code_to_remark_element(product_code);
    if (remark_element == null) {
        return;
    }
    const amount_as_number = trans_product_code_to_amount_number_as_number(product_code);
    const remark_str = remark_element.value;
    // white spaces בעתיד אולי כדאי לבדוק גם לגביremark_str כרגע אנחנו בודקים את אורך של
    // white spaces בעתיד אולי כדאי לבדוק גם לגביremark_str כרגע אנחנו בודקים את אורך של
    // white spaces בעתיד אולי כדאי לבדוק גם לגביremark_str כרגע אנחנו בודקים את אורך של
    if (remark_str.length == 0 && amount_as_number == 0) {
        turn_off_main_checkbox_if_only_main_checkbox_checked(product_code);
    }
    if (remark_str.length > 0) {
        turn_on_main_checkbox_if_both_unchecked(product_code);
        set_amount_to_1_if_exist_and_if_empty(product_code);
    }
    scan_all();
    update_elements_of_sums();
}



function supper_correct_alert_message_for_adding_one_to_amount(product_code: number) {
    const product_name: string = trans_product_code_to_product_name(product_code);
    let msg_str = "";
    msg_str += "בעיה במוצר" + ": " + "\n\n";
    msg_str += product_name + "\n\n";
    msg_str += "מוצר זה סומן אבל אין סימון של כמות" + "\n\n";
    msg_str += "מציב כמות 1 למוצר זה" + "\n\n";
    if (false) {
        alert(msg_str);
    }
}

function supper_correct(): void {
    // supper_correct is a temporary name
    // supper_correct is a temporary name
    // supper_correct is a temporary name
    // מסומן אבל אין כמות checkbox מטרת הפונקציה הזאת היא לשים כמות של 1 במקום שיש שאחד ה
    // מסומן אבל אין כמות checkbox מטרת הפונקציה הזאת היא לשים כמות של 1 במקום שיש שאחד ה
    // מסומן אבל אין כמות checkbox מטרת הפונקציה הזאת היא לשים כמות של 1 במקום שיש שאחד ה

    // BUG מצב זה בא לתקן בעיה אם קורית 
    // BUG מצב זה בא לתקן בעיה אם קורית 
    // BUG מצב זה בא לתקן בעיה אם קורית 
    // BUG מצב זה בא לתקן בעיה אם קורית 
    //debugger;
    const list_of_product_codes = create_list_of_all_product_codes();
    for (let i = 0; i < list_of_product_codes.length; i++) {
        const product_code = list_of_product_codes[i];
        if (product_has_checkboxes_and_at_least_one_is_checked(product_code) == true) {
            if (amount_element_exist_for_product(product_code) == true) {
                if (amount_element_is_empty_or_contain_zero(product_code) == true) {
                    //let product_name = trans_product_code_to_product_name(product_code);
                    //alert(`product_name=${product_name}`);    
                    supper_correct_alert_message_for_adding_one_to_amount(product_code);
                    put_string_in_amount_element_for_product(product_code, "1");
                }
            }
        }
    }
}



function GET_STRING_FOR_LANG_the_event_is_locked_the_form_cannot_be_submitted(p_lang: string): string {

    if (p_lang == "he") return "האירוע נעול. לא ניתן לשלוח את הטופס";
    else if (p_lang == "en") return "The event is locked. The form cannot be submitted";
    else if (p_lang == "ru") return "Событие закрыто. Форму нельзя отправить";
    else return "????";
}


function GET_STRING_FOR_LANG_you_selected_fewer_items_than_the_quantity_you_are_entitled_to(p_lang: string, zacaut_plus_factor: number, actual_sum: number): string {

    if (p_lang == "he") {
        // change: 2-8-26 (1)
        let msg = "";
        //msg += "שימו לב: בחרתם פחות פריטים מכמות הפריטים לה אתם זכאים" + "\n";
        //msg += "אתם זכאים לכל היותר ל" + ": " + zacaut_plus_factor + " " + "מוצרים" + "\n";
        //msg += "עליכם לבחור מוצרים נוספים" + ": " + "\n";
        //msg += "האם ברצונכם לשלוח את ההזמנה בכל זאת" + "?" + "\n";
        msg += "שימו לב: בחרתם פחות מוצרים מהכמות לה אתם זכאים." + "\n";
        msg += "אתם זכאים ל-" + zacaut_plus_factor + " מוצרים השבוע, בחרתם רק " + actual_sum + ". באפשרותכם לבחור מוצרים נוספים." + "\n";
        msg += "האם ברצונכם לשלוח את ההזמנה בכל זאת?";
        return msg;
    }
    else if (p_lang == "en") {
        let msg = "";
        msg += "Please note: You selected fewer items than the quantity you are entitled to" + "\n";
        msg += "You are entitled to at most" + ": " + zacaut_plus_factor + " " + "Products" + "\n";
        msg += "You must select additional products" + ": " + "\n";
        msg += "Do you wish to submit the order anyway" + "?" + "\n";
        return msg;
    }
    else if (p_lang == "ru") {
        let msg = "";
        msg += "Обратите внимание: вы выбрали меньше товаров, чем вам положено.\n";
        msg += "Максимально допустимое количество: " + zacaut_plus_factor + " товаров.\n";
        msg += "Вам необходимо выбрать дополнительные товары.\n";
        msg += "Вы хотите отправить заказ несмотря на это?\n";
        return msg;
    }
    else {
        return "????";
    }
}

function GET_STRING_FOR_LANG_you_selected_more_items_than_the_quantity_you_are_entitled_to(p_lang: string, zacaut_plus_factor: number, actual_sum: number): string {

    if (p_lang == "he") {
        let msg = "";
        // change: 2-8-26 (2)
        //msg += "שימו לב: בחרתם יותר פריטים מכמות הפריטים לה אתם זכאים" + "\n";
        //msg += "אתם זכאים לכל היותר ל" + ": " + zacaut_plus_factor + " " + "מוצרים" + "\n";
        //msg += "עליכם להפחית את מספר המוצרים" + ": " + "\n";
        msg += "שימו לב: בחרתם יותר מוצרים מהכמות לה אתם זכאים." + "\n";
        msg += "אתם זכאים ל-" + zacaut_plus_factor + " מוצרים השבוע, בחרתם " + actual_sum + "." + "\n";
        msg += "עליכם להפחית את כמות המוצרים שבחרתם.";
        return msg;
    }
    else if (p_lang == "en") {
        let msg = "";
        msg += "Please note: You selected more items than the quantity you are entitled to.\n";
        msg += "You are entitled to at most: " + zacaut_plus_factor + " products.\n";
        msg += "You must reduce the number of products.\n";
        return msg;
    }
    else if (p_lang == "ru") {
        let msg = "";
        msg += "Обратите внимание: вы выбрали больше товаров, чем вам положено.\n";
        msg += "Максимально допустимое количество: " + zacaut_plus_factor + " товаров.\n";
        msg += "Вам необходимо уменьшить количество товаров.\n";
        return msg;
    }
    else {
        return "????";
    }
}

function GET_STRING_FOR_LANG_you_selected_too_many_products_for_category(p_lang: string, category_name: string, category_limit: number, actual_sum: number): string {

    if (p_lang == "he") {
        let msg = "";
        // change: 2-8-26 (3)
        //msg += "שימו לב: בחרתם יותר מידי מוצרים לקטגוריה" + " " + category_name + "." + "\n";
        //msg += "אתם זכאים לכל היותר ל" + ": " + category_limit + " " + "מוצרים לקטגוריה זו" + "\n";
        //msg += "אתם בחרתם" + " " + actual_sum + " " + "לקטגוריה זו" + "." + "\n";
        //msg += "עליכם להפחית את מספר המוצרים לקטגוריה זו" + "\n";

        msg += "שימו לב: בחרתם יותר מידי מוצרים בקטגוריית " + category_name + "." + "\n";
        msg += "אתם זכאים לכל היותר ל-" + category_limit + " מוצרים בקטגוריה זו, אבל בחרתם " + actual_sum + "." + "\n";
        msg += "יש להפחית את מספר המוצרים בקטגוריה.";

        return msg;
    }
    else if (p_lang == "en") {
        let msg = "";
        msg += "Please note: You have selected too many products for the category " + category_name + "." + "\n";
        msg += "You are allowed to select up to: " + category_limit + " products for this category." + "\n";
        msg += "You have selected " + actual_sum + " products for this category." + "\n";
        msg += "Please reduce the number of products for this category." + "\n";
        return msg;
    }
    else if (p_lang == "ru") {
        let msg = "";
        msg += "Обратите внимание: Вы выбрали слишком много товаров для категории " + category_name + "." + "\n";
        msg += "Вы можете выбрать не более " + category_limit + " товаров для этой категории." + "\n";
        msg += "Вы выбрали " + actual_sum + " товаров для этой категории." + "\n";
        msg += "Пожалуйста, уменьшите количество товаров для этой категории." + "\n";
        return msg;
    }    else {
        return "????";
    }
}




function GET_STRING_FOR_LANG_missing_at_least_3_second_choice(p_lang: string, sum_of_second_option: number): string {
    const pde: HTMLElement = document.getElementById("id-page-data"); // pde = Page Data Element
    const minimum_second_choice: number = Number(pde.dataset.minimum_second_choice);
    if (p_lang == "he") {
        // change: 2-8-26 (4)
        let msg = "";
        //msg += "סימנת" + " " + sum_of_second_option + " מוצרים בעדיפות שניה" + "\n";
        //msg += `שים לב: יש לסמן בנוסף לזכאות לפחות ${minimum_second_choice} מוצרים בעדיפות שניה` + "\n";
        //msg += "נספרים רק מוצרים שמשויכת להם כמות" + "\n";
        msg += "שימו לב: בחרתם רק " + sum_of_second_option + " מוצרים בעדיפות שניה. השבוע יש לבחור לפחות " + minimum_second_choice + " מוצרים." + "\n";
        msg += "בעדיפות שניה נספרים רק מוצרים שמשויכת להם כמות (לחמים למשל אינם נספרים).";

        return msg;
    }
    else if (p_lang == "en") {
        let msg = "";
        msg += "You have selected " + sum_of_second_option + " products as second choice" + "\n";
        msg += `Note: You must select at least ${minimum_second_choice} products as second choice in addition to eligibility` + "\n";
        msg += "Only products with assigned quantities are counted" + "\n";
        return msg;
    }
    else if (p_lang == "ru") {
        let msg = "";
        msg += "Вы выбрали " + sum_of_second_option + " товаров в качестве второго приоритета" + "\n";
        msg += `Внимание: необходимо выбрать как минимум ${minimum_second_choice} товара второго приоритета` + "\n";
        msg += "Считаются только товары с указанным количеством" + "\n";
        return msg;    }
    else {
        return "????";
    }
}

//<<<<<<<<<<<<<<<<
//<<<<<<<<<<<<<<<<
//<<<<<<<<<<<<<<<<


async function call_alert(str: string, p_panel_back_color = "blue"): Promise<void> {
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף


    // ConfirmPlus ל confirm פונקציה חדשה במטרה לעבור מ
    // ConfirmPlus ל confirm פונקציה חדשה במטרה לעבור מ
    const pde: HTMLElement = document.getElementById("id-page-data"); // pde = Page Data Element
    const LNG: string = pde.dataset.lang;


    const use_AlertPlus: boolean = true;
    if (use_AlertPlus == true) {
        const style_rec = new PopupPlusStyleRecord();
        style_rec.panel_element_BackgroundColor = p_panel_back_color;
        style_rec.lang = LNG;
        if (LNG == "he") {
            style_rec.direction = "rtl";
        }
        if (LNG == "en" || LNG == "ru") {
            style_rec.direction = "ltr";
        }
        await AlertPlus.ShowAsync(str, null, style_rec);
    }
    else {
        // we use the original confirm
        alert(str);
    }
}


async function call_confirm(str: string, p_panel_back_color = "blue"): Promise<boolean> {
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף
    // בקריאה לפונקציה הזאת "await" חשוב מאד!!! לא לשכוח להוסיף

    const pde: HTMLElement = document.getElementById("id-page-data"); // pde = Page Data Element
    const LNG: string = pde.dataset.lang;
    // ConfirmPlus ל confirm פונקציה חדשה במטרה לעבור מ
    // ConfirmPlus ל confirm פונקציה חדשה במטרה לעבור מ
    const use_ConfirmPlus: boolean = true;
    if (use_ConfirmPlus == true) {
        const style_rec = new PopupPlusStyleRecord();
        style_rec.panel_element_BackgroundColor = p_panel_back_color;
        style_rec.lang = LNG;
        if (LNG == "he") {
            style_rec.direction = "rtl";
        }
        if (LNG == "en" || LNG == "ru") {
            style_rec.direction = "ltr";
        }
        const bval: boolean = await ConfirmPlus.ShowAsync(str, null, style_rec);
        return bval;
    }
    else {
        // we use the original confirm
        return confirm(str);
    }
}



function slow_trans_category_code_to_CategoryInfo(p_category_code: number): CategoryInfo {
    for (let i = 0; i < window.list_of_categories.length; i++) {
        const rec: CategoryInfo = window.list_of_categories[i];
        if (p_category_code == rec.code) {
            return rec;
        }
    }
    return null;
}

function slow_trans_category_code_to_category_limit(p_category_code: number): number {
    const rec: CategoryInfo = slow_trans_category_code_to_CategoryInfo(p_category_code);
    if (rec != null) {
        return rec.limit;
    }
    else {
        return 0;
    }
}

function slow_trans_category_code_to_category_name(p_category_code: number): string {
    const rec: CategoryInfo = slow_trans_category_code_to_CategoryInfo(p_category_code);
    if (rec != null) {
        return rec.name;
    }
    else {
        return "???";
    }
}


// פונקציה שמחזירה מערך של קודי/מספרי המוצרים השייכים לקטגוריה
function trans_category_code_to_list_of_product_codes(category_code: number): number[] {
    const selector = `.cl-product-container[data-category_code="${category_code}"]`;
    const list_of_product_element = document.querySelectorAll<HTMLElement>(selector);
    //alert(`length=${list_of_product_element.length}`);
    const list_of_product_codes: number[] = [];
    for (let i = 0; i < list_of_product_element.length; i++) {
        const product_element = list_of_product_element[i];
        const product_code = UTL.extract_last_number_from_string_as_number(product_element.id);
        list_of_product_codes.push(product_code);
    }
    return list_of_product_codes;
}

function call_sum_of_amounts_to_category(category_code: number): number {
    let sum: number = 0;
    const list_of_product_codes: number[] = trans_category_code_to_list_of_product_codes(category_code);
    for (let i = 0; i < list_of_product_codes.length; i++) {
        const product_code: number = list_of_product_codes[i];
        const product_element: HTMLElement = trans_product_code_to_product_element(product_code);
        const checkbox1_element: HTMLInputElement = trans_product_code_to_checkbox1_element(product_code);
        const checkbox2_element: HTMLInputElement = trans_product_code_to_checkbox2_element(product_code);
        const amount_element: HTMLInputElement = trans_product_code_to_amount_element(product_code);
        const has_amount: boolean = product_has_amount_element(product_code);
        if (amount_element != null) {
            const bval = checkbox1_element.checked;
            if (bval == true) { // אנחנו סוכמים רק מה שהוזמן 
                const amount_as_number: number = trans_string_to_number(amount_element.value);
                if (amount_as_number != 0) {
                    sum = sum + amount_as_number;
                }
            }
        }
    }
    return sum;
}





async function check_for_category_limits(LNG: string): Promise<boolean> {
    // אם יש בעיה כלשהי false אם הכל בסדר ו true אמור להחזיר
    // אם יש בעיה כלשהי false אם הכל בסדר ו true אמור להחזיר
    // אם יש בעיה כלשהי false אם הכל בסדר ו true אמור להחזיר

    // call_alert() :פונקציה זו היא אסינכרונית כיוון שהיא קוראת ל
    // call_alert() :פונקציה זו היא אסינכרונית כיוון שהיא קוראת ל
    // call_alert() :פונקציה זו היא אסינכרונית כיוון שהיא קוראת ל
    const list_of_category_codes: number[] = create_list_of_all_category_codes();
    for (let i = 0; i < list_of_category_codes.length; i++) {
        const category_code: number = list_of_category_codes[i];
        const category_name: string = slow_trans_category_code_to_category_name(category_code);
        const category_limit: number = slow_trans_category_code_to_category_limit(category_code);
        const sum: number = call_sum_of_amounts_to_category(category_code);
        //alert(`category_code ${category_code} category_name ${category_name} category_limit ${category_limit} sum=${sum}`);
        if (sum > category_limit) {

            const MSG = GET_STRING_FOR_LANG_you_selected_too_many_products_for_category(LNG, category_name, category_limit, sum);
            await call_alert(MSG, "red");
            return false; // i.e. problem
        }
    }
    return true; // i.e everything ok
}


async function validateAndSubmit(): Promise<void> {
    debugger;
    const org_code: number = get_org_code();
    const client_code: number = get_client_code();
    const event_code: number = get_event_code();
    const volunteer_code: number = get_volunteer_code();
    const pde: HTMLElement = document.getElementById("id-page-data"); // pde = Page Data Element
    const LNG: string = pde.dataset.lang;
    const minimum_second_choice: number = Number(pde.dataset.minimum_second_choice);

    if (true) {
        // if-false כיוון שעדיין לא בדקנו את זה אנחנו מכניסים את זה ב
        // if-false כיוון שעדיין לא בדקנו את זה אנחנו מכניסים את זה ב
        const all_category_limies_ok: boolean = await check_for_category_limits(LNG); // call_alert() :פונקציה זו היא אסינכרונית כיוון שהיא קוראת ל
        if (all_category_limies_ok == false) {
            return;
        }
    }


    const is_locked: boolean = await cmux_event_is_locked(event_code);
    if (is_locked == true) {
        const MSG = GET_STRING_FOR_LANG_the_event_is_locked_the_form_cannot_be_submitted(LNG);
        //alert(MSG);
        await call_alert(MSG, "red");
        return;
    }

    supper_correct();
    scan_all();

    const zacaut_plus_factor: number = fetch_zacaut_plus_factor_number_as_number();
    if (check_if_each_amounts_are_ok() == false) {
        return;
    }
    if (is_sum_of_all_amounts_is_too_small() == true) {
        const MSG: string = GET_STRING_FOR_LANG_you_selected_fewer_items_than_the_quantity_you_are_entitled_to(LNG, zacaut_plus_factor, globalVar_sum);
        if (await call_confirm(MSG, "green") == false) {
            return
        }
    }
    if (is_sum_of_all_amounts_is_too_big() == true) {
        const MSG: string = GET_STRING_FOR_LANG_you_selected_more_items_than_the_quantity_you_are_entitled_to(LNG, zacaut_plus_factor, globalVar_sum);
        await call_alert(MSG, "red");
        return;
    }

    debugger

    if (var_sum_of_second_option < minimum_second_choice) {
        const MSG = GET_STRING_FOR_LANG_missing_at_least_3_second_choice(LNG, var_sum_of_second_option);
        await call_alert(MSG, "red");
        return;
    }


    if (true) {
        // כאן אנחנו מוסיפים את ההודעה על מנת שהלקוח ימתין עד לסיום השידור לשרות
        // כאן אנחנו מוסיפים את ההודעה על מנת שהלקוח ימתין עד לסיום השידור לשרות
        if (false) {
            // this is the old wait
            create_trasmintion_message_please_wait_old();
            await UTL.sleep_async(500);
        }
        create_trasmintion_message_please_wait();
        await UTL.sleep_async(1000);
    }

    const form: HTMLFormElement = document.getElementById("id-form") as HTMLFormElement;
    UTL.add_hidden_input_to_form(form, "viewport", `${window.innerWidth}x${window.innerHeight}`);
    //alert("before submit");
    form.submit();  // Trigger form submission
}        

function get_org_code(): number {
    const element: HTMLInputElement = document.getElementById("id-org-code") as HTMLInputElement;
    if (element == null) {
        alert("element == null");
    }
    const org_code = TRANS.trans_string_to_int(element.value);
    return org_code;
}

function get_client_code(): number {
    const element: HTMLInputElement = document.getElementById("id-client-code") as HTMLInputElement;
    if (element == null) {
        alert("element == null");
    }
    const client_code = TRANS.trans_string_to_int(element.value);
    return client_code;
}

function get_event_code(): number {
    const element: HTMLInputElement = document.getElementById("id-event-code") as HTMLInputElement;
    if (element == null) {
        alert("element == null");
    }
    const event_code = TRANS.trans_string_to_int(element.value);
    return event_code;
}

function get_volunteer_code(): number {
    const element: HTMLInputElement = document.getElementById("id-volunteer-code") as HTMLInputElement;
    if (element == null) {
        alert("element == null");
    }
    const volunteer_code: number = TRANS.trans_string_to_int(element.value);
    return volunteer_code;
}

function create_trasmintion_message_please_wait_old(): void {
    const overlay_element: HTMLElement = document.createElement("div");
    overlay_element.style.position = "fixed";
    overlay_element.style.top = "0";
    overlay_element.style.left = "0";
    overlay_element.style.width = "100%";
    overlay_element.style.height = "100%";
    overlay_element.style.backgroundColor = "rgba(0, 0, 0, 0.5)"; // Semi-transparent black
    overlay_element.style.zIndex = "1000"; // Ensure overlay is on top
    //------------------------------------
    const popup_element: HTMLElement = document.createElement("div");
    popup_element.id = "id-DIALOG1-popup";
    popup_element.style.position = "absolute";
    popup_element.style.backgroundColor = "red";
    popup_element.style.padding = "0px";
    popup_element.style.borderRadius = "8px";
    popup_element.style.width = "220px";
    //popup_element.style.height = "220px";
    popup_element.style.textAlign = "center";
    popup_element.style.padding = "20px";
    popup_element.innerHTML = "בקשתכם בתהליך<br>קליטה<br>אנא המתינו...";
    popup_element.style.fontSize = "30px";
    popup_element.style.fontWeight = "bold";
    //------------------------------------
    overlay_element.appendChild(popup_element);
    document.body.appendChild(overlay_element);
    UTL.center_popup_element_inside_overlay_element(popup_element, overlay_element);
}


function create_trasmintion_message_please_wait(): void {
    const style_rec: PopupPlusStyleRecord = PopupPlusAuxFunctions.create_rec_style_v1("rtl", "28px", false);
    style_rec.general_BackgroundColor = "red";
    style_rec.text_font_width = "bold";
    const msg_str: string = "בקשתכם בתהליך<br>קליטה<br>אנא המתינו..."
    //const caption: string = null; // caption כלומר שאנחנו לא רוצים
    AnnouncePlus.Open(msg_str, null, style_rec);
}


/*
function handlePageShow(event: KeyboardEvent): void {
    if (event.persisted || (window.performance && window.performance.navigation.type === 2))  {
        window.location.reload();
    }
}
*/

function handlePageShow(event: /*KeyboardEvent*/PageTransitionEvent): void {
    // BACK גם כאשר מבצעים reload התפקיד של פונקציה זו הוא ליצור מצב שהדף מבצע
    // BACK גם כאשר מבצעים reload התפקיד של פונקציה זו הוא ליצור מצב שהדף מבצע
    // BACK גם כאשר מבצעים reload התפקיד של פונקציה זו הוא ליצור מצב שהדף מבצע
    // BACK גם כאשר מבצעים reload התפקיד של פונקציה זו הוא ליצור מצב שהדף מבצע
    if (event == null || event == undefined) {
        alert(`cmux_client_cart.handlePageShow: event=${event} is null or undefined`);
        return;
    }


    const isPersisted = event.persisted;
    const entries = window.performance.getEntriesByType("navigation") as PerformanceNavigationTiming[];
    const isBackForward = entries.length > 0 && entries[0].type === "back_forward";
    if (isPersisted || isBackForward) {
        window.location.reload();
    }
}



function product_element_contains_something(product_code: number): boolean {
    // פונקציה חדשה מתאריך 10.4.2026
    // פונקציה חדשה מתאריך 10.4.2026
    // פונקציה חדשה מתאריך 10.4.2026
    const checkbox1_element: HTMLInputElement = trans_product_code_to_checkbox1_element(product_code);
    const checkbox2_element: HTMLInputElement = trans_product_code_to_checkbox2_element(product_code);
    const amount_element = trans_product_code_to_amount_element(product_code);
    const remark_element: HTMLInputElement = trans_product_code_to_remark_element(product_code) as HTMLInputElement;
    if (checkbox1_element != null && checkbox1_element.checked == true) {
        return true;
    }
    if (checkbox2_element != null && checkbox2_element.checked == true) {
        return true;
    }
    if (amount_element != null) {
        const amount_contains_something: boolean = amount_element.value !== "" && parseInt(amount_element.value) > 0;
        if (amount_contains_something == true) {
            return true;
        }
    }
    if (remark_element != null) {
        const has_remark: boolean = remark_element.value.trim().length > 0;
        if (has_remark == true) {
            return true;
        }
    }
    //------------
    return false;
}




function assign_backgroundColor_to_form_element(background_color_str: string): void {
    const form_element: HTMLFormElement = document.getElementById("id-form") as HTMLFormElement;
    form_element.style.backgroundColor = background_color_str;
}

function assign_backgroundColor_to_all_product_elements(background_color_str: string): void {
    const list_of_product_codes: number[] = create_list_of_all_product_codes(); // new
    for (let i = 0; i < list_of_product_codes.length; i++) {
        const product_code: number = list_of_product_codes[i];
        const product_element: HTMLElement = trans_product_code_to_product_element(product_code);
        product_element.style.backgroundColor = background_color_str;
    }
}


function respond_filter_checkbox_checked_is_false(): void {
    // פונקציה זו תפקידה להציג את כל המוצרים
    // פונקציה זו תפקידה להציג את כל המוצרים
    // פונקציה זו תפקידה להציג את כל המוצרים
    //const form: HTMLFormElement = document.getElementById("id-form") as HTMLFormElement;
    //form.style.backgroundColor = "white";

    assign_backgroundColor_to_form_element("white");
    assign_backgroundColor_to_all_product_elements("white");

    // במצב זה אנחנו רוצים להציג את כל הקבוצות
    // במצב זה אנחנו רוצים להציג את כל הקבוצות
    // במצב זה אנחנו רוצים להציג את כל הקבוצות
    
    const list_of_group_codes: number[] = create_list_of_all_group_codes(); // new
    for (let i = 0; i < list_of_group_codes.length; i++) {
        const group_code: number = list_of_group_codes[i];
        const group_element: HTMLElement = trans_group_code_to_group_element(group_code);
        //const group_hr_element: HTMLElement = trans_group_code_to_group_hr_element(group_code);
        group_element.style.display = "block";
    }


    const list_of_product_codes: number[] = create_list_of_all_product_codes(); // new
    for (let i = 0; i < list_of_product_codes.length; i++) {
        const product_code: number = list_of_product_codes[i];
        const product_element: HTMLElement = trans_product_code_to_product_element(product_code);
        const product_hr_element: HTMLElement = trans_product_code_to_product_hr_element(product_code);
        const has_something: boolean = product_element_contains_something(product_code);
        product_element.style.display = "block";
        product_hr_element.style.display = "block";
        //product_element.style.backgroundColor = "white";
    }
}

function respond_filter_checkbox_checked_is_true(): void {
    debugger;
    // פונקציה זו תפקידה להציג את המוצרים שהלקוח הזין בהם ערך כלשהו
    // פונקציה זו תפקידה להציג את המוצרים שהלקוח הזין בהם ערך כלשהו
    // פונקציה זו תפקידה להציג את המוצרים שהלקוח הזין בהם ערך כלשהו
    //const form: HTMLFormElement = document.getElementById("id-form") as HTMLFormElement;
    //form.style.backgroundColor = "yellow";
    assign_backgroundColor_to_form_element("gray");
    assign_backgroundColor_to_all_product_elements("lightgray");

    // במצב זה אנחנו רוצים להחביא את כל הקבוצות
    // במצב זה אנחנו רוצים להחביא את כל הקבוצות
    const list_of_group_codes: number[] = create_list_of_all_group_codes(); // new
    for (let i = 0; i < list_of_group_codes.length; i++) {
        const group_code: number = list_of_group_codes[i];
        const group_element: HTMLElement = trans_group_code_to_group_element(group_code);
        const group_hr_element: HTMLElement = trans_group_code_to_group_hr_element(group_code);
        group_element.style.display = "none";
        group_hr_element.style.display = "none";
    }


    const list_of_product_codes: number[] = create_list_of_all_product_codes(); // new
    for (let i = 0; i < list_of_product_codes.length; i++) {
        const product_code: number = list_of_product_codes[i];
        const product_element: HTMLElement = trans_product_code_to_product_element(product_code);
        const product_hr_element: HTMLElement = trans_product_code_to_product_hr_element(product_code);
        const has_something: boolean = product_element_contains_something(product_code);
        if (has_something == true) {
            product_element.style.display = "block";
            //product_element.style.backgroundColor = "yellow";
            product_hr_element.style.display = "block";
        }
        if (has_something == false) {
            product_element.style.display = "none";
            //product_element.style.backgroundColor = "yellow";
            product_hr_element.style.display = "none";
        }
    }
}



function respond_filter_checkbox(p_is_checked: boolean): void {
    if (p_is_checked == false) {
        respond_filter_checkbox_checked_is_false();
    }
    if (p_is_checked == true) {
        respond_filter_checkbox_checked_is_true();
    }
}



export const cmux_client_cart_wrapper = {
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה
    // export הוא להוות אובייקט למטרת wrapper המטרה של ה

    // add here page show

    scan_all,
    handlePageShow,
    respond_amount_plus_button,
    respond_amount_minus_button,
    respond_to_input_amount_and_input_remark_change,
    respond_remark_input_changed,
    respond_checkbox1_change,
    respond_checkbox2_change,
    respond_filter_checkbox,
    validateAndSubmit,
};


if (false) {
    // cshtml ולכן אנחנו מעבירים אותם לקובץ ה vite להזכיך שהפעולות בבלוק זה עשו לנו בעיות במעבר ל
    // cshtml ולכן אנחנו מעבירים אותם לקובץ ה vite להזכיך שהפעולות בבלוק זה עשו לנו בעיות במעבר ל
    window.onload = scan_all;
    window.addEventListener('pageshow', handlePageShow);
}
